import cookie from 'react-cookies';
import queryString from 'query-string';

// Constants.
import * as AuthConstants from 'constants/AuthConstants';
import * as ProfileConstants from 'constants/ProfileConstants';
import * as ErrorConstants from 'constants/ErrorConstants';
import { ACCESS_TOKEN_COOKIE } from 'utils/auth/authConstants';

const query = queryString.parse(window.location.search);
let isAuthenticated = !!(
  cookie.load('csrftoken') ||
  cookie.load(ACCESS_TOKEN_COOKIE) ||
  cookie.load('welltorysessionid') ||
  query.token !== undefined
);

const initialState = {
  isLoading: false,
  isLoaded: false,
  userType: isAuthenticated ? 'full' : 'anonymous',
  isAuthenticated: isAuthenticated,
  message: '',
};

export default function auth(state = initialState, action = {}) {
  switch (action.type) {
    case AuthConstants.CLEAR_COOKIE_REQUEST:
    case AuthConstants.CLEAR_COOKIE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        userType: 'anonymous',
        isAuthenticated: false,
        message: '',
      };
    case AuthConstants.LOGIN_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        isAuthenticated: false,
        message: '',
      };
    case AuthConstants.LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        userType: action.userType,
        isAuthenticated: true,
      };
    case AuthConstants.LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        userType: 'anonymous',
        isAuthenticated: false,
        message: action.message,
      };
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        userType: action.userType,
        isAuthenticated: !!(
          cookie.load('csrftoken') ||
          cookie.load(ACCESS_TOKEN_COOKIE)
        ),
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case ProfileConstants.LOAD_PROFILE_FAILURE:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        isAuthenticated: false,
        message: '',
      };
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        message: '',
      };
    default:
      return state;
  }
}
